export const getPaliBase = (word: string): string[] => {
  let parent = new Map<string, number>();
  paliEnding.forEach((value) => {
    if (value.type !== ".v." && !value.grammar.includes(".voc.")) {
      let sEnd2 = word.slice(0 - value.end2.length);
      if (sEnd2 === value.end2) {
        const wordParent = word.slice(0, 0 - value.end2.length) + value.end1;
        parent.set(wordParent, wordParent.length);
      }
    }
  });
  let output: string[] = [];
  parent.forEach((value, key, map) => {
    output.push(key);
  });
  output.sort((a, b) => a.length - b.length);
  return output;
};
export const paliEndingType = ["n", "ti", "v", "ind", "pron", "num", "adj"];
export const paliEndingGrammar = [
  "nom",
  "acc",
  "gen",
  "dat",
  "inst",
  "abl",
  "loc",
  "voc",
  "sg",
  "pl",
  "m",
  "nt",
  "f",
  "1p",
  "2p",
  "3p",
  "pres",
  "aor",
  "fut",
  "pf",
  "imp",
  "cond",
  "adv",
  "conj",
  "abs",
  "ger",
  "inf",
];
export const paliEnding = [
  {
    end1: "a",
    end2: "o",
    type: ".n.",
    grammar: ".m.$.sg.$.nom.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "a",
    type: ".n.",
    grammar: ".m.$.sg.$.voc.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "ā",
    type: ".n.",
    grammar: ".m.$.sg.$.voc.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "aṃ",
    type: ".n.",
    grammar: ".m.$.sg.$.acc.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "assa",
    type: ".n.",
    grammar: ".m.$.sg.$.gen.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "assa",
    type: ".n.",
    grammar: ".m.$.sg.$.dat.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "āya",
    type: ".n.",
    grammar: ".m.$.sg.$.dat.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "ena",
    type: ".n.",
    grammar: ".m.$.sg.$.inst.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "ā",
    type: ".n.",
    grammar: ".m.$.sg.$.abl.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "asmā",
    type: ".n.",
    grammar: ".m.$.sg.$.abl.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "amhā",
    type: ".n.",
    grammar: ".m.$.sg.$.abl.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "ato",
    type: ".n.",
    grammar: ".m.$.sg.$.abl.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "e",
    type: ".n.",
    grammar: ".m.$.sg.$.loc.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "asmiṃ",
    type: ".n.",
    grammar: ".m.$.sg.$.loc.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "amhi",
    type: ".n.",
    grammar: ".m.$.sg.$.loc.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "ā",
    type: ".n.",
    grammar: ".m.$.pl.$.nom.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "āse",
    type: ".n.",
    grammar: ".m.$.pl.$.nom.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "ā",
    type: ".n.",
    grammar: ".m.$.pl.$.voc.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "e",
    type: ".n.",
    grammar: ".m.$.pl.$.acc.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "ānaṃ",
    type: ".n.",
    grammar: ".m.$.pl.$.gen.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "ānaṃ",
    type: ".n.",
    grammar: ".m.$.pl.$.dat.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "ehi",
    type: ".n.",
    grammar: ".m.$.pl.$.inst.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "ebhi",
    type: ".n.",
    grammar: ".m.$.pl.$.inst.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "ehi",
    type: ".n.",
    grammar: ".m.$.pl.$.abl.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "ebhi",
    type: ".n.",
    grammar: ".m.$.pl.$.abl.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "esu",
    type: ".n.",
    grammar: ".m.$.pl.$.loc.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "aṃ",
    type: ".n.",
    grammar: ".nt.$.sg.$.nom.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "a",
    type: ".n.",
    grammar: ".nt.$.sg.$.voc.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "aṃ",
    type: ".n.",
    grammar: ".nt.$.sg.$.acc.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "assa",
    type: ".n.",
    grammar: ".nt.$.sg.$.gen.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "assa",
    type: ".n.",
    grammar: ".nt.$.sg.$.dat.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "āya",
    type: ".n.",
    grammar: ".nt.$.sg.$.dat.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "ena",
    type: ".n.",
    grammar: ".nt.$.sg.$.inst.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "ā",
    type: ".n.",
    grammar: ".nt.$.sg.$.abl.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "asmā",
    type: ".n.",
    grammar: ".nt.$.sg.$.abl.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "amhā",
    type: ".n.",
    grammar: ".nt.$.sg.$.abl.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "ato",
    type: ".n.",
    grammar: ".nt.$.sg.$.abl.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "e",
    type: ".n.",
    grammar: ".nt.$.sg.$.loc.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "asmiṃ",
    type: ".n.",
    grammar: ".nt.$.sg.$.loc.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "amhi",
    type: ".n.",
    grammar: ".nt.$.sg.$.loc.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "āni",
    type: ".n.",
    grammar: ".nt.$.pl.$.nom.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "ā",
    type: ".n.",
    grammar: ".nt.$.pl.$.nom.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "āni",
    type: ".n.",
    grammar: ".nt.$.pl.$.voc.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "ā",
    type: ".n.",
    grammar: ".nt.$.pl.$.voc.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "āni",
    type: ".n.",
    grammar: ".nt.$.pl.$.acc.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "e",
    type: ".n.",
    grammar: ".nt.$.pl.$.acc.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "ānaṃ",
    type: ".n.",
    grammar: ".nt.$.pl.$.gen.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "ānaṃ",
    type: ".n.",
    grammar: ".nt.$.pl.$.dat.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "ehi",
    type: ".n.",
    grammar: ".nt.$.pl.$.inst.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "ebhi",
    type: ".n.",
    grammar: ".nt.$.pl.$.inst.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "ehi",
    type: ".n.",
    grammar: ".nt.$.pl.$.abl.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "ebhi",
    type: ".n.",
    grammar: ".nt.$.pl.$.abl.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "esu",
    type: ".n.",
    grammar: ".nt.$.pl.$.loc.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "assā",
    type: ".n.",
    grammar: ".m.$.sg.$.gen.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "assā",
    type: ".n.",
    grammar: ".m.$.sg.$.dat.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "enā",
    type: ".n.",
    grammar: ".m.$.sg.$.inst.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "amhī",
    type: ".n.",
    grammar: ".m.$.sg.$.loc.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "ehī",
    type: ".n.",
    grammar: ".m.$.pl.$.inst.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "ebhī",
    type: ".n.",
    grammar: ".m.$.pl.$.inst.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "ehī",
    type: ".n.",
    grammar: ".m.$.pl.$.abl.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "ebhī",
    type: ".n.",
    grammar: ".m.$.pl.$.abl.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "esū",
    type: ".n.",
    grammar: ".m.$.pl.$.loc.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "assā",
    type: ".n.",
    grammar: ".nt.$.sg.$.gen.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "assā",
    type: ".n.",
    grammar: ".nt.$.sg.$.dat.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "enā",
    type: ".n.",
    grammar: ".nt.$.sg.$.inst.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "amhī",
    type: ".n.",
    grammar: ".nt.$.sg.$.loc.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "ānī",
    type: ".n.",
    grammar: ".nt.$.pl.$.nom.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "ānī",
    type: ".n.",
    grammar: ".nt.$.pl.$.voc.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "ānī",
    type: ".n.",
    grammar: ".nt.$.pl.$.acc.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "ehī",
    type: ".n.",
    grammar: ".nt.$.pl.$.inst.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "ebhī",
    type: ".n.",
    grammar: ".nt.$.pl.$.inst.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "ehī",
    type: ".n.",
    grammar: ".nt.$.pl.$.abl.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "ebhī",
    type: ".n.",
    grammar: ".nt.$.pl.$.abl.",
    confidence: "100",
  },
  {
    end1: "a",
    end2: "esū",
    type: ".n.",
    grammar: ".nt.$.pl.$.loc.",
    confidence: "100",
  },
  {
    end1: "ā",
    end2: "ā",
    type: ".n.",
    grammar: ".f.$.sg.$.nom.",
    confidence: "100",
  },
  {
    end1: "ā",
    end2: "ā",
    type: ".n.",
    grammar: ".f.$.sg.$.voc.",
    confidence: "100",
  },
  {
    end1: "ā",
    end2: "e",
    type: ".n.",
    grammar: ".f.$.sg.$.voc.",
    confidence: "100",
  },
  {
    end1: "ā",
    end2: "aṃ",
    type: ".n.",
    grammar: ".f.$.sg.$.acc.",
    confidence: "100",
  },
  {
    end1: "ā",
    end2: "āya",
    type: ".n.",
    grammar: ".f.$.sg.$.gen.",
    confidence: "100",
  },
  {
    end1: "ā",
    end2: "āya",
    type: ".n.",
    grammar: ".f.$.sg.$.dat.",
    confidence: "100",
  },
  {
    end1: "ā",
    end2: "āya",
    type: ".n.",
    grammar: ".f.$.sg.$.inst.",
    confidence: "100",
  },
  {
    end1: "ā",
    end2: "āya",
    type: ".n.",
    grammar: ".f.$.sg.$.abl.",
    confidence: "100",
  },
  {
    end1: "ā",
    end2: "ato",
    type: ".n.",
    grammar: ".f.$.sg.$.abl.",
    confidence: "100",
  },
  {
    end1: "ā",
    end2: "āya",
    type: ".n.",
    grammar: ".f.$.sg.$.loc.",
    confidence: "100",
  },
  {
    end1: "ā",
    end2: "āyaṃ",
    type: ".n.",
    grammar: ".f.$.sg.$.loc.",
    confidence: "100",
  },
  {
    end1: "ā",
    end2: "ā",
    type: ".n.",
    grammar: ".f.$.pl.$.nom.",
    confidence: "100",
  },
  {
    end1: "ā",
    end2: "āyo",
    type: ".n.",
    grammar: ".f.$.pl.$.nom.",
    confidence: "100",
  },
  {
    end1: "ā",
    end2: "ā",
    type: ".n.",
    grammar: ".f.$.pl.$.voc.",
    confidence: "100",
  },
  {
    end1: "ā",
    end2: "āyo",
    type: ".n.",
    grammar: ".f.$.pl.$.voc.",
    confidence: "100",
  },
  {
    end1: "ā",
    end2: "ā",
    type: ".n.",
    grammar: ".f.$.pl.$.acc.",
    confidence: "100",
  },
  {
    end1: "ā",
    end2: "āyo",
    type: ".n.",
    grammar: ".f.$.pl.$.acc.",
    confidence: "100",
  },
  {
    end1: "ā",
    end2: "ānaṃ",
    type: ".n.",
    grammar: ".f.$.pl.$.gen.",
    confidence: "100",
  },
  {
    end1: "ā",
    end2: "ānaṃ",
    type: ".n.",
    grammar: ".f.$.pl.$.dat.",
    confidence: "100",
  },
  {
    end1: "ā",
    end2: "āhi",
    type: ".n.",
    grammar: ".f.$.pl.$.inst.",
    confidence: "100",
  },
  {
    end1: "ā",
    end2: "ābhi",
    type: ".n.",
    grammar: ".f.$.pl.$.inst.",
    confidence: "100",
  },
  {
    end1: "ā",
    end2: "āhi",
    type: ".n.",
    grammar: ".f.$.pl.$.abl.",
    confidence: "100",
  },
  {
    end1: "ā",
    end2: "ābhi",
    type: ".n.",
    grammar: ".f.$.pl.$.abl.",
    confidence: "100",
  },
  {
    end1: "ā",
    end2: "āsu",
    type: ".n.",
    grammar: ".f.$.pl.$.loc.",
    confidence: "100",
  },
  {
    end1: "ā",
    end2: "āhī",
    type: ".n.",
    grammar: ".f.$.pl.$.inst.",
    confidence: "100",
  },
  {
    end1: "ā",
    end2: "ābhī",
    type: ".n.",
    grammar: ".f.$.pl.$.inst.",
    confidence: "100",
  },
  {
    end1: "ā",
    end2: "āhī",
    type: ".n.",
    grammar: ".f.$.pl.$.abl.",
    confidence: "100",
  },
  {
    end1: "ā",
    end2: "ābhī",
    type: ".n.",
    grammar: ".f.$.pl.$.abl.",
    confidence: "100",
  },
  {
    end1: "ā",
    end2: "āsū",
    type: ".n.",
    grammar: ".f.$.pl.$.loc.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "i",
    type: ".n.",
    grammar: ".m.$.sg.$.nom.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "i",
    type: ".n.",
    grammar: ".m.$.sg.$.voc.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "iṃ",
    type: ".n.",
    grammar: ".m.$.sg.$.acc.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "issa",
    type: ".n.",
    grammar: ".m.$.sg.$.gen.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "ino",
    type: ".n.",
    grammar: ".m.$.sg.$.gen.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "issa",
    type: ".n.",
    grammar: ".m.$.sg.$.dat.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "ino",
    type: ".n.",
    grammar: ".m.$.sg.$.dat.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "inā",
    type: ".n.",
    grammar: ".m.$.sg.$.inst.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "inā",
    type: ".n.",
    grammar: ".m.$.sg.$.abl.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "ismā",
    type: ".n.",
    grammar: ".m.$.sg.$.abl.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "imhā",
    type: ".n.",
    grammar: ".m.$.sg.$.abl.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "ismiṃ",
    type: ".n.",
    grammar: ".m.$.sg.$.loc.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "imhi",
    type: ".n.",
    grammar: ".m.$.sg.$.loc.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "ī",
    type: ".n.",
    grammar: ".m.$.pl.$.nom.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "ayo",
    type: ".n.",
    grammar: ".m.$.pl.$.nom.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "ī",
    type: ".n.",
    grammar: ".m.$.pl.$.voc.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "ayo",
    type: ".n.",
    grammar: ".m.$.pl.$.voc.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "ī",
    type: ".n.",
    grammar: ".m.$.pl.$.acc.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "ayo",
    type: ".n.",
    grammar: ".m.$.pl.$.acc.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "īnaṃ",
    type: ".n.",
    grammar: ".m.$.pl.$.gen.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "īnaṃ",
    type: ".n.",
    grammar: ".m.$.pl.$.dat.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "īhi",
    type: ".n.",
    grammar: ".m.$.pl.$.inst.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "ībhi",
    type: ".n.",
    grammar: ".m.$.pl.$.inst.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "īhi",
    type: ".n.",
    grammar: ".m.$.pl.$.abl.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "ībhi",
    type: ".n.",
    grammar: ".m.$.pl.$.abl.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "īsu",
    type: ".n.",
    grammar: ".m.$.pl.$.loc.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "i",
    type: ".n.",
    grammar: ".nt.$.sg.$.nom.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "i",
    type: ".n.",
    grammar: ".nt.$.sg.$.voc.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "iṃ",
    type: ".n.",
    grammar: ".nt.$.sg.$.acc.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "assa",
    type: ".n.",
    grammar: ".nt.$.sg.$.gen.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "ino",
    type: ".n.",
    grammar: ".nt.$.sg.$.gen.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "assa",
    type: ".n.",
    grammar: ".nt.$.sg.$.dat.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "ino",
    type: ".n.",
    grammar: ".nt.$.sg.$.dat.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "inā",
    type: ".n.",
    grammar: ".nt.$.sg.$.inst.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "inā",
    type: ".n.",
    grammar: ".nt.$.sg.$.abl.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "ismā",
    type: ".n.",
    grammar: ".nt.$.sg.$.abl.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "imhā",
    type: ".n.",
    grammar: ".nt.$.sg.$.abl.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "ismiṃ",
    type: ".n.",
    grammar: ".nt.$.sg.$.loc.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "imhi",
    type: ".n.",
    grammar: ".nt.$.sg.$.loc.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "īni",
    type: ".n.",
    grammar: ".nt.$.pl.$.nom.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "ī",
    type: ".n.",
    grammar: ".nt.$.pl.$.nom.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "īni",
    type: ".n.",
    grammar: ".nt.$.pl.$.voc.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "ī",
    type: ".n.",
    grammar: ".nt.$.pl.$.voc.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "īni",
    type: ".n.",
    grammar: ".nt.$.pl.$.acc.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "ī",
    type: ".n.",
    grammar: ".nt.$.pl.$.acc.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "īnaṃ",
    type: ".n.",
    grammar: ".nt.$.pl.$.gen.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "īnaṃ",
    type: ".n.",
    grammar: ".nt.$.pl.$.dat.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "īhi",
    type: ".n.",
    grammar: ".nt.$.pl.$.inst.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "ībhi",
    type: ".n.",
    grammar: ".nt.$.pl.$.inst.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "īhi",
    type: ".n.",
    grammar: ".nt.$.pl.$.abl.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "ībhi",
    type: ".n.",
    grammar: ".nt.$.pl.$.abl.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "īsu",
    type: ".n.",
    grammar: ".nt.$.pl.$.loc.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "i",
    type: ".n.",
    grammar: ".f.$.sg.$.nom.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "i",
    type: ".n.",
    grammar: ".f.$.sg.$.voc.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "iṃ",
    type: ".n.",
    grammar: ".f.$.sg.$.acc.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "iyā",
    type: ".n.",
    grammar: ".f.$.sg.$.gen.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "iyā",
    type: ".n.",
    grammar: ".f.$.sg.$.dat.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "iyā",
    type: ".n.",
    grammar: ".f.$.sg.$.inst.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "iyā",
    type: ".n.",
    grammar: ".f.$.sg.$.abl.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "iyā",
    type: ".n.",
    grammar: ".f.$.sg.$.loc.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "yā",
    type: ".n.",
    grammar: ".f.$.sg.$.loc.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "iyaṃ",
    type: ".n.",
    grammar: ".f.$.sg.$.loc.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "yaṃ",
    type: ".n.",
    grammar: ".f.$.sg.$.loc.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "ī",
    type: ".n.",
    grammar: ".f.$.pl.$.nom.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "iyo",
    type: ".n.",
    grammar: ".f.$.pl.$.nom.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "ī",
    type: ".n.",
    grammar: ".f.$.pl.$.voc.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "iyo",
    type: ".n.",
    grammar: ".f.$.pl.$.voc.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "ī",
    type: ".n.",
    grammar: ".f.$.pl.$.acc.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "iyo",
    type: ".n.",
    grammar: ".f.$.pl.$.acc.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "īnaṃ",
    type: ".n.",
    grammar: ".f.$.pl.$.gen.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "īnaṃ",
    type: ".n.",
    grammar: ".f.$.pl.$.dat.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "īhi",
    type: ".n.",
    grammar: ".f.$.pl.$.inst.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "ībhi",
    type: ".n.",
    grammar: ".f.$.pl.$.inst.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "īhi",
    type: ".n.",
    grammar: ".f.$.pl.$.abl.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "ībhi",
    type: ".n.",
    grammar: ".f.$.pl.$.abl.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "īsu",
    type: ".n.",
    grammar: ".f.$.pl.$.loc.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "ihi",
    type: ".n.",
    grammar: ".nt.$.pl.$.inst.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "ibhi",
    type: ".n.",
    grammar: ".nt.$.pl.$.inst.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "ihi",
    type: ".n.",
    grammar: ".nt.$.pl.$.abl.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "ibhi",
    type: ".n.",
    grammar: ".nt.$.pl.$.abl.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "inaṃ",
    type: ".n.",
    grammar: ".nt.$.pl.$.gen.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "inaṃ",
    type: ".n.",
    grammar: ".nt.$.pl.$.dat.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "isu",
    type: ".n.",
    grammar: ".nt.$.pl.$.loc.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "issā",
    type: ".n.",
    grammar: ".m.$.sg.$.gen.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "issā",
    type: ".n.",
    grammar: ".m.$.sg.$.dat.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "imhī",
    type: ".n.",
    grammar: ".m.$.sg.$.loc.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "īhī",
    type: ".n.",
    grammar: ".m.$.pl.$.inst.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "ībhī",
    type: ".n.",
    grammar: ".m.$.pl.$.inst.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "īhī",
    type: ".n.",
    grammar: ".m.$.pl.$.abl.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "ībhī",
    type: ".n.",
    grammar: ".m.$.pl.$.abl.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "īsū",
    type: ".n.",
    grammar: ".m.$.pl.$.loc.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "assā",
    type: ".n.",
    grammar: ".nt.$.sg.$.gen.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "assā",
    type: ".n.",
    grammar: ".nt.$.sg.$.dat.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "imhī",
    type: ".n.",
    grammar: ".nt.$.sg.$.loc.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "īnī",
    type: ".n.",
    grammar: ".nt.$.pl.$.nom.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "īnī",
    type: ".n.",
    grammar: ".nt.$.pl.$.voc.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "īnī",
    type: ".n.",
    grammar: ".nt.$.pl.$.acc.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "īhī",
    type: ".n.",
    grammar: ".nt.$.pl.$.inst.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "ībhī",
    type: ".n.",
    grammar: ".nt.$.pl.$.inst.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "īhī",
    type: ".n.",
    grammar: ".nt.$.pl.$.abl.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "ībhī",
    type: ".n.",
    grammar: ".nt.$.pl.$.abl.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "īsū",
    type: ".n.",
    grammar: ".nt.$.pl.$.loc.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "īhī",
    type: ".n.",
    grammar: ".f.$.pl.$.inst.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "ībhī",
    type: ".n.",
    grammar: ".f.$.pl.$.inst.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "īhī",
    type: ".n.",
    grammar: ".f.$.pl.$.abl.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "ībhī",
    type: ".n.",
    grammar: ".f.$.pl.$.abl.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "īsū",
    type: ".n.",
    grammar: ".f.$.pl.$.loc.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "ihī",
    type: ".n.",
    grammar: ".nt.$.pl.$.inst.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "ibhī",
    type: ".n.",
    grammar: ".nt.$.pl.$.inst.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "ihī",
    type: ".n.",
    grammar: ".nt.$.pl.$.abl.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "ibhī",
    type: ".n.",
    grammar: ".nt.$.pl.$.abl.",
    confidence: "100",
  },
  {
    end1: "i",
    end2: "isū",
    type: ".n.",
    grammar: ".nt.$.pl.$.loc.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "ī",
    type: ".n.",
    grammar: ".m.$.sg.$.nom.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "ī",
    type: ".n.",
    grammar: ".m.$.sg.$.voc.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "iṃ",
    type: ".n.",
    grammar: ".m.$.sg.$.acc.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "inaṃ",
    type: ".n.",
    grammar: ".m.$.sg.$.acc.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "issa",
    type: ".n.",
    grammar: ".m.$.sg.$.gen.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "ino",
    type: ".n.",
    grammar: ".m.$.sg.$.gen.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "issa",
    type: ".n.",
    grammar: ".m.$.sg.$.dat.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "ino",
    type: ".n.",
    grammar: ".m.$.sg.$.dat.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "inā",
    type: ".n.",
    grammar: ".m.$.sg.$.inst.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "inā",
    type: ".n.",
    grammar: ".m.$.sg.$.abl.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "ismā",
    type: ".n.",
    grammar: ".m.$.sg.$.abl.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "imhā",
    type: ".n.",
    grammar: ".m.$.sg.$.abl.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "ismiṃ",
    type: ".n.",
    grammar: ".m.$.sg.$.loc.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "imhi",
    type: ".n.",
    grammar: ".m.$.sg.$.loc.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "ī",
    type: ".n.",
    grammar: ".m.$.pl.$.nom.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "ino",
    type: ".n.",
    grammar: ".m.$.pl.$.nom.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "ī",
    type: ".n.",
    grammar: ".m.$.pl.$.voc.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "ino",
    type: ".n.",
    grammar: ".m.$.pl.$.voc.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "ī",
    type: ".n.",
    grammar: ".m.$.pl.$.acc.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "ino",
    type: ".n.",
    grammar: ".m.$.pl.$.acc.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "inaṃ",
    type: ".n.",
    grammar: ".m.$.pl.$.gen.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "inaṃ",
    type: ".n.",
    grammar: ".m.$.pl.$.dat.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "īhi",
    type: ".n.",
    grammar: ".m.$.pl.$.inst.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "ībhi",
    type: ".n.",
    grammar: ".m.$.pl.$.inst.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "īhi",
    type: ".n.",
    grammar: ".m.$.pl.$.abl.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "ībhi",
    type: ".n.",
    grammar: ".m.$.pl.$.abl.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "īsu",
    type: ".n.",
    grammar: ".m.$.pl.$.loc.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "ī",
    type: ".n.",
    grammar: ".f.$.sg.$.nom.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "ī",
    type: ".n.",
    grammar: ".f.$.sg.$.voc.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "iṃ",
    type: ".n.",
    grammar: ".f.$.sg.$.acc.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "iyā",
    type: ".n.",
    grammar: ".f.$.sg.$.gen.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "ayā",
    type: ".n.",
    grammar: ".f.$.sg.$.gen.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "iyā",
    type: ".n.",
    grammar: ".f.$.sg.$.dat.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "ayā",
    type: ".n.",
    grammar: ".f.$.sg.$.dat.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "iyā",
    type: ".n.",
    grammar: ".f.$.sg.$.inst.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "ayā",
    type: ".n.",
    grammar: ".f.$.sg.$.inst.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "iyā",
    type: ".n.",
    grammar: ".f.$.sg.$.abl.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "ayā",
    type: ".n.",
    grammar: ".f.$.sg.$.abl.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "iyā",
    type: ".n.",
    grammar: ".f.$.sg.$.loc.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "ayā",
    type: ".n.",
    grammar: ".f.$.sg.$.loc.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "iyaṃ",
    type: ".n.",
    grammar: ".f.$.sg.$.loc.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "ayaṃ",
    type: ".n.",
    grammar: ".f.$.sg.$.loc.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "ī",
    type: ".n.",
    grammar: ".f.$.pl.$.nom.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "iyo",
    type: ".n.",
    grammar: ".f.$.pl.$.nom.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "ī",
    type: ".n.",
    grammar: ".f.$.pl.$.voc.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "iyo",
    type: ".n.",
    grammar: ".f.$.pl.$.voc.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "yo",
    type: ".n.",
    grammar: ".f.$.pl.$.voc.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "ī",
    type: ".n.",
    grammar: ".f.$.pl.$.acc.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "iyo",
    type: ".n.",
    grammar: ".f.$.pl.$.acc.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "yo",
    type: ".n.",
    grammar: ".f.$.pl.$.acc.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "īnaṃ",
    type: ".n.",
    grammar: ".f.$.pl.$.gen.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "īnaṃ",
    type: ".n.",
    grammar: ".f.$.pl.$.dat.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "īhi",
    type: ".n.",
    grammar: ".f.$.pl.$.inst.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "ībhi",
    type: ".n.",
    grammar: ".f.$.pl.$.inst.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "īhi",
    type: ".n.",
    grammar: ".f.$.pl.$.abl.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "ībhi",
    type: ".n.",
    grammar: ".f.$.pl.$.abl.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "īsu",
    type: ".n.",
    grammar: ".f.$.pl.$.loc.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "ini",
    type: ".n.",
    grammar: ".m.$.sg.$.loc.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "īnaṃ",
    type: ".n.",
    grammar: ".m.$.pl.$.gen.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "īnaṃ",
    type: ".n.",
    grammar: ".m.$.pl.$.dat.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "īsu",
    type: ".n.",
    grammar: ".m.$.pl.$.loc.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "ito",
    type: ".n.",
    grammar: ".m.$.sg.$.abl.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "i",
    type: ".n.",
    grammar: ".f.$.sg.$.nom.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "iyaṃ",
    type: ".n.",
    grammar: ".f.$.sg.$.acc.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "inaṃ",
    type: ".n.",
    grammar: ".f.$.pl.$.gen.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "inaṃ",
    type: ".n.",
    grammar: ".f.$.pl.$.dat.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "īyanaṃ",
    type: ".n.",
    grammar: ".f.$.pl.$.gen.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "īyanaṃ",
    type: ".n.",
    grammar: ".f.$.pl.$.dat.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "iyanaṃ",
    type: ".n.",
    grammar: ".f.$.pl.$.gen.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "iyanaṃ",
    type: ".n.",
    grammar: ".f.$.pl.$.dat.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "isu",
    type: ".n.",
    grammar: ".f.$.pl.$.loc.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "issā",
    type: ".n.",
    grammar: ".m.$.sg.$.gen.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "issā",
    type: ".n.",
    grammar: ".m.$.sg.$.dat.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "imhī",
    type: ".n.",
    grammar: ".m.$.sg.$.loc.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "īhī",
    type: ".n.",
    grammar: ".m.$.pl.$.inst.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "ībhī",
    type: ".n.",
    grammar: ".m.$.pl.$.inst.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "īhī",
    type: ".n.",
    grammar: ".m.$.pl.$.abl.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "ībhī",
    type: ".n.",
    grammar: ".m.$.pl.$.abl.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "īsū",
    type: ".n.",
    grammar: ".m.$.pl.$.loc.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "īhī",
    type: ".n.",
    grammar: ".f.$.pl.$.inst.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "ībhī",
    type: ".n.",
    grammar: ".f.$.pl.$.inst.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "īhī",
    type: ".n.",
    grammar: ".f.$.pl.$.abl.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "ībhī",
    type: ".n.",
    grammar: ".f.$.pl.$.abl.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "īsū",
    type: ".n.",
    grammar: ".f.$.pl.$.loc.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "īsū",
    type: ".n.",
    grammar: ".m.$.pl.$.loc.",
    confidence: "100",
  },
  {
    end1: "ī",
    end2: "isū",
    type: ".n.",
    grammar: ".f.$.pl.$.loc.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "u",
    type: ".n.",
    grammar: ".m.$.sg.$.nom.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "u",
    type: ".n.",
    grammar: ".m.$.sg.$.voc.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "uṃ",
    type: ".n.",
    grammar: ".m.$.sg.$.acc.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "ussa",
    type: ".n.",
    grammar: ".m.$.sg.$.gen.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "uno",
    type: ".n.",
    grammar: ".m.$.sg.$.gen.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "ussa",
    type: ".n.",
    grammar: ".m.$.sg.$.dat.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "uno",
    type: ".n.",
    grammar: ".m.$.sg.$.dat.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "unā",
    type: ".n.",
    grammar: ".m.$.sg.$.inst.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "unā",
    type: ".n.",
    grammar: ".m.$.sg.$.abl.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "usmā",
    type: ".n.",
    grammar: ".m.$.sg.$.abl.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "umhā",
    type: ".n.",
    grammar: ".m.$.sg.$.abl.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "usmiṃ",
    type: ".n.",
    grammar: ".m.$.sg.$.loc.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "umhi",
    type: ".n.",
    grammar: ".m.$.sg.$.loc.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "ū",
    type: ".n.",
    grammar: ".m.$.pl.$.nom.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "avo",
    type: ".n.",
    grammar: ".m.$.pl.$.nom.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "ū",
    type: ".n.",
    grammar: ".m.$.pl.$.voc.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "avo",
    type: ".n.",
    grammar: ".m.$.pl.$.voc.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "ave",
    type: ".n.",
    grammar: ".m.$.pl.$.voc.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "ū",
    type: ".n.",
    grammar: ".m.$.pl.$.acc.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "avo",
    type: ".n.",
    grammar: ".m.$.pl.$.acc.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "ūnaṃ",
    type: ".n.",
    grammar: ".m.$.pl.$.gen.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "ūnaṃ",
    type: ".n.",
    grammar: ".m.$.pl.$.dat.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "ūhi",
    type: ".n.",
    grammar: ".m.$.pl.$.inst.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "ūbhi",
    type: ".n.",
    grammar: ".m.$.pl.$.inst.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "ūhi",
    type: ".n.",
    grammar: ".m.$.pl.$.abl.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "ūbhi",
    type: ".n.",
    grammar: ".m.$.pl.$.abl.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "ūsu",
    type: ".n.",
    grammar: ".m.$.pl.$.loc.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "u",
    type: ".n.",
    grammar: ".nt.$.sg.$.nom.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "u",
    type: ".n.",
    grammar: ".nt.$.sg.$.voc.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "uṃ",
    type: ".n.",
    grammar: ".nt.$.sg.$.acc.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "ussa",
    type: ".n.",
    grammar: ".nt.$.sg.$.gen.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "uno",
    type: ".n.",
    grammar: ".nt.$.sg.$.gen.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "ussa",
    type: ".n.",
    grammar: ".nt.$.sg.$.dat.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "uno",
    type: ".n.",
    grammar: ".nt.$.sg.$.dat.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "unā",
    type: ".n.",
    grammar: ".nt.$.sg.$.inst.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "unā",
    type: ".n.",
    grammar: ".nt.$.sg.$.abl.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "usmā",
    type: ".n.",
    grammar: ".nt.$.sg.$.abl.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "umhā",
    type: ".n.",
    grammar: ".nt.$.sg.$.abl.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "usmiṃ",
    type: ".n.",
    grammar: ".nt.$.sg.$.loc.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "umhi",
    type: ".n.",
    grammar: ".nt.$.sg.$.loc.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "ū",
    type: ".n.",
    grammar: ".nt.$.pl.$.nom.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "ūni",
    type: ".n.",
    grammar: ".nt.$.pl.$.nom.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "ū",
    type: ".n.",
    grammar: ".nt.$.pl.$.voc.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "ūni",
    type: ".n.",
    grammar: ".nt.$.pl.$.voc.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "ū",
    type: ".n.",
    grammar: ".nt.$.pl.$.acc.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "ūni",
    type: ".n.",
    grammar: ".nt.$.pl.$.acc.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "ūnaṃ",
    type: ".n.",
    grammar: ".nt.$.pl.$.gen.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "ūnaṃ",
    type: ".n.",
    grammar: ".nt.$.pl.$.dat.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "ūhi",
    type: ".n.",
    grammar: ".nt.$.pl.$.inst.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "ūbhi",
    type: ".n.",
    grammar: ".nt.$.pl.$.inst.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "ūhi",
    type: ".n.",
    grammar: ".nt.$.pl.$.abl.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "ūbhi",
    type: ".n.",
    grammar: ".nt.$.pl.$.abl.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "ūsu",
    type: ".n.",
    grammar: ".nt.$.pl.$.loc.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "u",
    type: ".n.",
    grammar: ".f.$.sg.$.nom.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "u",
    type: ".n.",
    grammar: ".f.$.sg.$.voc.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "uṃ",
    type: ".n.",
    grammar: ".f.$.sg.$.acc.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "uyā",
    type: ".n.",
    grammar: ".f.$.sg.$.gen.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "uyā",
    type: ".n.",
    grammar: ".f.$.sg.$.dat.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "uyā",
    type: ".n.",
    grammar: ".f.$.sg.$.inst.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "uyā",
    type: ".n.",
    grammar: ".f.$.sg.$.abl.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "uto",
    type: ".n.",
    grammar: ".f.$.sg.$.abl.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "uyā",
    type: ".n.",
    grammar: ".f.$.sg.$.loc.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "uyaṃ",
    type: ".n.",
    grammar: ".f.$.sg.$.loc.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "ū",
    type: ".n.",
    grammar: ".f.$.pl.$.nom.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "uyo",
    type: ".n.",
    grammar: ".f.$.pl.$.nom.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "ūvo",
    type: ".n.",
    grammar: ".f.$.pl.$.nom.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "ū",
    type: ".n.",
    grammar: ".f.$.pl.$.voc.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "uyo",
    type: ".n.",
    grammar: ".f.$.pl.$.voc.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "ū",
    type: ".n.",
    grammar: ".f.$.pl.$.acc.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "uyo",
    type: ".n.",
    grammar: ".f.$.pl.$.acc.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "ūnaṃ",
    type: ".n.",
    grammar: ".f.$.pl.$.gen.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "ūnaṃ",
    type: ".n.",
    grammar: ".f.$.pl.$.dat.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "ūhi",
    type: ".n.",
    grammar: ".f.$.pl.$.inst.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "ūbhi",
    type: ".n.",
    grammar: ".f.$.pl.$.inst.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "ūhi",
    type: ".n.",
    grammar: ".f.$.pl.$.abl.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "ūbhi",
    type: ".n.",
    grammar: ".f.$.pl.$.abl.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "ūsu",
    type: ".n.",
    grammar: ".f.$.pl.$.loc.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "ussā",
    type: ".n.",
    grammar: ".m.$.sg.$.gen.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "ussā",
    type: ".n.",
    grammar: ".m.$.sg.$.dat.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "umhī",
    type: ".n.",
    grammar: ".m.$.sg.$.loc.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "ūhī",
    type: ".n.",
    grammar: ".m.$.pl.$.inst.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "ūbhī",
    type: ".n.",
    grammar: ".m.$.pl.$.inst.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "ūhī",
    type: ".n.",
    grammar: ".m.$.pl.$.abl.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "ūbhī",
    type: ".n.",
    grammar: ".m.$.pl.$.abl.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "ūsū",
    type: ".n.",
    grammar: ".m.$.pl.$.loc.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "ussā",
    type: ".n.",
    grammar: ".nt.$.sg.$.gen.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "ussā",
    type: ".n.",
    grammar: ".nt.$.sg.$.dat.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "umhī",
    type: ".n.",
    grammar: ".nt.$.sg.$.loc.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "ūnī",
    type: ".n.",
    grammar: ".nt.$.pl.$.nom.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "ūnī",
    type: ".n.",
    grammar: ".nt.$.pl.$.voc.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "ūnī",
    type: ".n.",
    grammar: ".nt.$.pl.$.acc.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "ūhī",
    type: ".n.",
    grammar: ".nt.$.pl.$.inst.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "ūbhī",
    type: ".n.",
    grammar: ".nt.$.pl.$.inst.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "ūhī",
    type: ".n.",
    grammar: ".nt.$.pl.$.abl.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "ūbhī",
    type: ".n.",
    grammar: ".nt.$.pl.$.abl.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "ūsū",
    type: ".n.",
    grammar: ".nt.$.pl.$.loc.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "ūhī",
    type: ".n.",
    grammar: ".f.$.pl.$.inst.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "ūbhī",
    type: ".n.",
    grammar: ".f.$.pl.$.inst.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "ūhī",
    type: ".n.",
    grammar: ".f.$.pl.$.abl.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "ūbhī",
    type: ".n.",
    grammar: ".f.$.pl.$.abl.",
    confidence: "100",
  },
  {
    end1: "u",
    end2: "ūsū",
    type: ".n.",
    grammar: ".f.$.pl.$.loc.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "ū",
    type: ".n.",
    grammar: ".m.$.sg.$.nom.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "ū",
    type: ".n.",
    grammar: ".m.$.sg.$.voc.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "uṃ",
    type: ".n.",
    grammar: ".m.$.sg.$.acc.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "ussa",
    type: ".n.",
    grammar: ".m.$.sg.$.gen.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "uno",
    type: ".n.",
    grammar: ".m.$.sg.$.gen.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "ussa",
    type: ".n.",
    grammar: ".m.$.sg.$.dat.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "uno",
    type: ".n.",
    grammar: ".m.$.sg.$.dat.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "unā",
    type: ".n.",
    grammar: ".m.$.sg.$.inst.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "unā",
    type: ".n.",
    grammar: ".m.$.sg.$.abl.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "usmā",
    type: ".n.",
    grammar: ".m.$.sg.$.abl.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "umhā",
    type: ".n.",
    grammar: ".m.$.sg.$.abl.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "usmiṃ",
    type: ".n.",
    grammar: ".m.$.sg.$.loc.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "umhi",
    type: ".n.",
    grammar: ".m.$.sg.$.loc.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "ū",
    type: ".n.",
    grammar: ".m.$.pl.$.nom.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "avo",
    type: ".n.",
    grammar: ".m.$.pl.$.nom.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "ū",
    type: ".n.",
    grammar: ".m.$.pl.$.voc.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "avo",
    type: ".n.",
    grammar: ".m.$.pl.$.voc.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "ave",
    type: ".n.",
    grammar: ".m.$.pl.$.voc.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "ū",
    type: ".n.",
    grammar: ".m.$.pl.$.acc.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "avo",
    type: ".n.",
    grammar: ".m.$.pl.$.acc.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "ūnaṃ",
    type: ".n.",
    grammar: ".m.$.pl.$.gen.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "ūnaṃ",
    type: ".n.",
    grammar: ".m.$.pl.$.dat.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "ūhi",
    type: ".n.",
    grammar: ".m.$.pl.$.inst.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "ūbhi",
    type: ".n.",
    grammar: ".m.$.pl.$.inst.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "ūhi",
    type: ".n.",
    grammar: ".m.$.pl.$.abl.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "ūbhi",
    type: ".n.",
    grammar: ".m.$.pl.$.abl.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "ūsu",
    type: ".n.",
    grammar: ".m.$.pl.$.loc.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "ū",
    type: ".n.",
    grammar: ".f.$.sg.$.nom.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "ū",
    type: ".n.",
    grammar: ".f.$.sg.$.voc.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "uṃ",
    type: ".n.",
    grammar: ".f.$.sg.$.acc.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "uyā",
    type: ".n.",
    grammar: ".f.$.sg.$.gen.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "uyā",
    type: ".n.",
    grammar: ".f.$.sg.$.dat.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "uyā",
    type: ".n.",
    grammar: ".f.$.sg.$.inst.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "uyā",
    type: ".n.",
    grammar: ".f.$.sg.$.abl.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "uto",
    type: ".n.",
    grammar: ".f.$.sg.$.abl.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "uyā",
    type: ".n.",
    grammar: ".f.$.sg.$.loc.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "uyaṃ",
    type: ".n.",
    grammar: ".f.$.sg.$.loc.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "ū",
    type: ".n.",
    grammar: ".f.$.pl.$.nom.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "uyo",
    type: ".n.",
    grammar: ".f.$.pl.$.nom.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "ū",
    type: ".n.",
    grammar: ".f.$.pl.$.voc.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "uyo",
    type: ".n.",
    grammar: ".f.$.pl.$.voc.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "ū",
    type: ".n.",
    grammar: ".f.$.pl.$.acc.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "uyo",
    type: ".n.",
    grammar: ".f.$.pl.$.acc.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "ūnaṃ",
    type: ".n.",
    grammar: ".f.$.pl.$.gen.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "ūnaṃ",
    type: ".n.",
    grammar: ".f.$.pl.$.dat.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "ūhi",
    type: ".n.",
    grammar: ".f.$.pl.$.inst.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "ūbhi",
    type: ".n.",
    grammar: ".f.$.pl.$.inst.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "ūhi",
    type: ".n.",
    grammar: ".f.$.pl.$.abl.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "ūbhi",
    type: ".n.",
    grammar: ".f.$.pl.$.abl.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "ūsu",
    type: ".n.",
    grammar: ".f.$.pl.$.loc.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "ussā",
    type: ".n.",
    grammar: ".m.$.sg.$.gen.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "ussā",
    type: ".n.",
    grammar: ".m.$.sg.$.dat.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "umhī",
    type: ".n.",
    grammar: ".m.$.sg.$.loc.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "ūhī",
    type: ".n.",
    grammar: ".m.$.pl.$.inst.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "ūbhī",
    type: ".n.",
    grammar: ".m.$.pl.$.inst.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "ūhī",
    type: ".n.",
    grammar: ".m.$.pl.$.abl.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "ūbhī",
    type: ".n.",
    grammar: ".m.$.pl.$.abl.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "ūsū",
    type: ".n.",
    grammar: ".m.$.pl.$.loc.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "ūhī",
    type: ".n.",
    grammar: ".f.$.pl.$.inst.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "ūbhī",
    type: ".n.",
    grammar: ".f.$.pl.$.inst.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "ūhī",
    type: ".n.",
    grammar: ".f.$.pl.$.abl.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "ūbhī",
    type: ".n.",
    grammar: ".f.$.pl.$.abl.",
    confidence: "100",
  },
  {
    end1: "ū",
    end2: "ūsū",
    type: ".n.",
    grammar: ".f.$.pl.$.loc.",
    confidence: "100",
  },
  {
    end1: "ati",
    end2: "etha",
    type: ".v.",
    grammar: ".3p.$.sg.$.opt.",
    confidence: "100",
  },
  {
    end1: "ati",
    end2: "eraṃ",
    type: ".v.",
    grammar: ".3p.$.pl.$.opt.",
    confidence: "100",
  },
  {
    end1: "ati",
    end2: "issati",
    type: ".v.",
    grammar: ".3p.$.sg.$.fut.",
    confidence: "100",
  },
  {
    end1: "ati",
    end2: "issanti",
    type: ".v.",
    grammar: ".3p.$.pl.$.fut.",
    confidence: "100",
  },
  {
    end1: "ati",
    end2: "issate",
    type: ".v.",
    grammar: ".3p.$.sg.$.fut.",
    confidence: "100",
  },
  {
    end1: "ati",
    end2: "issante",
    type: ".v.",
    grammar: ".3p.$.pl.$.fut.",
    confidence: "100",
  },
  {
    end1: "ati",
    end2: "issare",
    type: ".v.",
    grammar: ".3p.$.pl.$.fut.",
    confidence: "100",
  },
  {
    end1: "ati",
    end2: "e",
    type: ".v.",
    grammar: ".1p.$.sg.$.imp.",
    confidence: "100",
  },
  {
    end1: "ati",
    end2: "āmase",
    type: ".v.",
    grammar: ".1p.$.pl.$.imp.",
    confidence: "100",
  },
  {
    end1: "ati",
    end2: "eyyāmi",
    type: ".v.",
    grammar: ".1p.$.sg.$.opt.",
    confidence: "100",
  },
  {
    end1: "ati",
    end2: "eyyāma",
    type: ".v.",
    grammar: ".1p.$.pl.$.opt.",
    confidence: "100",
  },
  {
    end1: "ati",
    end2: "eyyaṃ",
    type: ".v.",
    grammar: ".1p.$.sg.$.opt.",
    confidence: "100",
  },
  {
    end1: "ati",
    end2: "eyyāmhe",
    type: ".v.",
    grammar: ".1p.$.pl.$.opt.",
    confidence: "100",
  },
  {
    end1: "ati",
    end2: "issāmi",
    type: ".v.",
    grammar: ".1p.$.sg.$.fut.",
    confidence: "100",
  },
  {
    end1: "ati",
    end2: "issāma",
    type: ".v.",
    grammar: ".1p.$.pl.$.fut.",
    confidence: "100",
  },
  {
    end1: "ati",
    end2: "issaṃ",
    type: ".v.",
    grammar: ".1p.$.sg.$.fut.",
    confidence: "100",
  },
  {
    end1: "ati",
    end2: "issāmhe",
    type: ".v.",
    grammar: ".1p.$.pl.$.fut.",
    confidence: "100",
  },
  {
    end1: "ati",
    end2: "issāmase",
    type: ".v.",
    grammar: ".1p.$.pl.$.fut.",
    confidence: "100",
  },
  {
    end1: "ati",
    end2: "eyyāsi",
    type: ".v.",
    grammar: ".2p.$.sg.$.opt.",
    confidence: "100",
  },
  {
    end1: "ati",
    end2: "eyyātha",
    type: ".v.",
    grammar: ".2p.$.pl.$.opt.",
    confidence: "100",
  },
  {
    end1: "ati",
    end2: "etho",
    type: ".v.",
    grammar: ".2p.$.sg.$.opt.",
    confidence: "100",
  },
  {
    end1: "ati",
    end2: "eyyavho",
    type: ".v.",
    grammar: ".2p.$.pl.$.opt.",
    confidence: "100",
  },
  {
    end1: "ati",
    end2: "issasi",
    type: ".v.",
    grammar: ".2p.$.sg.$.fut.",
    confidence: "100",
  },
  {
    end1: "ati",
    end2: "issatha",
    type: ".v.",
    grammar: ".2p.$.pl.$.fut.",
    confidence: "100",
  },
  {
    end1: "ati",
    end2: "issase",
    type: ".v.",
    grammar: ".2p.$.sg.$.fut.",
    confidence: "100",
  },
  {
    end1: "ati",
    end2: "issavhe",
    type: ".v.",
    grammar: ".2p.$.pl.$.fut.",
    confidence: "100",
  },
  {
    end1: "āti",
    end2: "etha",
    type: ".v.",
    grammar: ".3p.$.sg.$.opt.",
    confidence: "100",
  },
  {
    end1: "āti",
    end2: "eraṃ",
    type: ".v.",
    grammar: ".3p.$.pl.$.opt.",
    confidence: "100",
  },
  {
    end1: "āti",
    end2: "issati",
    type: ".v.",
    grammar: ".3p.$.sg.$.fut.",
    confidence: "100",
  },
  {
    end1: "āti",
    end2: "issanti",
    type: ".v.",
    grammar: ".3p.$.pl.$.fut.",
    confidence: "100",
  },
  {
    end1: "āti",
    end2: "issate",
    type: ".v.",
    grammar: ".3p.$.sg.$.fut.",
    confidence: "100",
  },
  {
    end1: "āti",
    end2: "issante",
    type: ".v.",
    grammar: ".3p.$.pl.$.fut.",
    confidence: "100",
  },
  {
    end1: "āti",
    end2: "issare",
    type: ".v.",
    grammar: ".3p.$.pl.$.fut.",
    confidence: "100",
  },
  {
    end1: "āti",
    end2: "e",
    type: ".v.",
    grammar: ".1p.$.sg.$.imp.",
    confidence: "100",
  },
  {
    end1: "āti",
    end2: "āmase",
    type: ".v.",
    grammar: ".1p.$.pl.$.imp.",
    confidence: "100",
  },
  {
    end1: "āti",
    end2: "eyyāmi",
    type: ".v.",
    grammar: ".1p.$.sg.$.opt.",
    confidence: "100",
  },
  {
    end1: "āti",
    end2: "eyyāma",
    type: ".v.",
    grammar: ".1p.$.pl.$.opt.",
    confidence: "100",
  },
  {
    end1: "āti",
    end2: "eyyaṃ",
    type: ".v.",
    grammar: ".1p.$.sg.$.opt.",
    confidence: "100",
  },
  {
    end1: "āti",
    end2: "eyyāmhe",
    type: ".v.",
    grammar: ".1p.$.pl.$.opt.",
    confidence: "100",
  },
  {
    end1: "āti",
    end2: "issāmi",
    type: ".v.",
    grammar: ".1p.$.sg.$.fut.",
    confidence: "100",
  },
  {
    end1: "āti",
    end2: "issāma",
    type: ".v.",
    grammar: ".1p.$.pl.$.fut.",
    confidence: "100",
  },
  {
    end1: "āti",
    end2: "issaṃ",
    type: ".v.",
    grammar: ".1p.$.sg.$.fut.",
    confidence: "100",
  },
  {
    end1: "āti",
    end2: "issāmhe",
    type: ".v.",
    grammar: ".1p.$.pl.$.fut.",
    confidence: "100",
  },
  {
    end1: "āti",
    end2: "issāmase",
    type: ".v.",
    grammar: ".1p.$.pl.$.fut.",
    confidence: "100",
  },
  {
    end1: "āti",
    end2: "eyyāsi",
    type: ".v.",
    grammar: ".2p.$.sg.$.opt.",
    confidence: "100",
  },
  {
    end1: "āti",
    end2: "eyyātha",
    type: ".v.",
    grammar: ".2p.$.pl.$.opt.",
    confidence: "100",
  },
  {
    end1: "āti",
    end2: "etho",
    type: ".v.",
    grammar: ".2p.$.sg.$.opt.",
    confidence: "100",
  },
  {
    end1: "āti",
    end2: "eyyavho",
    type: ".v.",
    grammar: ".2p.$.pl.$.opt.",
    confidence: "100",
  },
  {
    end1: "āti",
    end2: "issasi",
    type: ".v.",
    grammar: ".2p.$.sg.$.fut.",
    confidence: "100",
  },
  {
    end1: "āti",
    end2: "issatha",
    type: ".v.",
    grammar: ".2p.$.pl.$.fut.",
    confidence: "100",
  },
  {
    end1: "āti",
    end2: "issase",
    type: ".v.",
    grammar: ".2p.$.sg.$.fut.",
    confidence: "100",
  },
  {
    end1: "āti",
    end2: "issavhe",
    type: ".v.",
    grammar: ".2p.$.pl.$.fut.",
    confidence: "100",
  },
  {
    end1: "eti",
    end2: "etha",
    type: ".v.",
    grammar: ".3p.$.sg.$.opt.",
    confidence: "100",
  },
  {
    end1: "eti",
    end2: "eraṃ",
    type: ".v.",
    grammar: ".3p.$.pl.$.opt.",
    confidence: "100",
  },
  {
    end1: "eti",
    end2: "issati",
    type: ".v.",
    grammar: ".3p.$.sg.$.fut.",
    confidence: "100",
  },
  {
    end1: "eti",
    end2: "issanti",
    type: ".v.",
    grammar: ".3p.$.pl.$.fut.",
    confidence: "100",
  },
  {
    end1: "eti",
    end2: "issate",
    type: ".v.",
    grammar: ".3p.$.sg.$.fut.",
    confidence: "100",
  },
  {
    end1: "eti",
    end2: "issante",
    type: ".v.",
    grammar: ".3p.$.pl.$.fut.",
    confidence: "100",
  },
  {
    end1: "eti",
    end2: "issare",
    type: ".v.",
    grammar: ".3p.$.pl.$.fut.",
    confidence: "100",
  },
  {
    end1: "eti",
    end2: "e",
    type: ".v.",
    grammar: ".1p.$.sg.$.imp.",
    confidence: "100",
  },
  {
    end1: "eti",
    end2: "āmase",
    type: ".v.",
    grammar: ".1p.$.pl.$.imp.",
    confidence: "100",
  },
  {
    end1: "eti",
    end2: "eyyāmi",
    type: ".v.",
    grammar: ".1p.$.sg.$.opt.",
    confidence: "100",
  },
  {
    end1: "eti",
    end2: "eyyāma",
    type: ".v.",
    grammar: ".1p.$.pl.$.opt.",
    confidence: "100",
  },
  {
    end1: "eti",
    end2: "eyyaṃ",
    type: ".v.",
    grammar: ".1p.$.sg.$.opt.",
    confidence: "100",
  },
  {
    end1: "eti",
    end2: "eyyāmhe",
    type: ".v.",
    grammar: ".1p.$.pl.$.opt.",
    confidence: "100",
  },
  {
    end1: "eti",
    end2: "issāmi",
    type: ".v.",
    grammar: ".1p.$.sg.$.fut.",
    confidence: "100",
  },
  {
    end1: "eti",
    end2: "issāma",
    type: ".v.",
    grammar: ".1p.$.pl.$.fut.",
    confidence: "100",
  },
  {
    end1: "eti",
    end2: "issaṃ",
    type: ".v.",
    grammar: ".1p.$.sg.$.fut.",
    confidence: "100",
  },
  {
    end1: "eti",
    end2: "issāmhe",
    type: ".v.",
    grammar: ".1p.$.pl.$.fut.",
    confidence: "100",
  },
  {
    end1: "eti",
    end2: "issāmase",
    type: ".v.",
    grammar: ".1p.$.pl.$.fut.",
    confidence: "100",
  },
  {
    end1: "eti",
    end2: "eyyāsi",
    type: ".v.",
    grammar: ".2p.$.sg.$.opt.",
    confidence: "100",
  },
  {
    end1: "eti",
    end2: "eyyātha",
    type: ".v.",
    grammar: ".2p.$.pl.$.opt.",
    confidence: "100",
  },
  {
    end1: "eti",
    end2: "etho",
    type: ".v.",
    grammar: ".2p.$.sg.$.opt.",
    confidence: "100",
  },
  {
    end1: "eti",
    end2: "eyyavho",
    type: ".v.",
    grammar: ".2p.$.pl.$.opt.",
    confidence: "100",
  },
  {
    end1: "eti",
    end2: "issasi",
    type: ".v.",
    grammar: ".2p.$.sg.$.fut.",
    confidence: "100",
  },
  {
    end1: "eti",
    end2: "issatha",
    type: ".v.",
    grammar: ".2p.$.pl.$.fut.",
    confidence: "100",
  },
  {
    end1: "eti",
    end2: "issase",
    type: ".v.",
    grammar: ".2p.$.sg.$.fut.",
    confidence: "100",
  },
  {
    end1: "eti",
    end2: "issavhe",
    type: ".v.",
    grammar: ".2p.$.pl.$.fut.",
    confidence: "100",
  },
  {
    end1: "oti",
    end2: "etha",
    type: ".v.",
    grammar: ".3p.$.sg.$.opt.",
    confidence: "100",
  },
  {
    end1: "oti",
    end2: "eraṃ",
    type: ".v.",
    grammar: ".3p.$.pl.$.opt.",
    confidence: "100",
  },
  {
    end1: "oti",
    end2: "issati",
    type: ".v.",
    grammar: ".3p.$.sg.$.fut.",
    confidence: "100",
  },
  {
    end1: "oti",
    end2: "issanti",
    type: ".v.",
    grammar: ".3p.$.pl.$.fut.",
    confidence: "100",
  },
  {
    end1: "oti",
    end2: "issate",
    type: ".v.",
    grammar: ".3p.$.sg.$.fut.",
    confidence: "100",
  },
  {
    end1: "oti",
    end2: "issante",
    type: ".v.",
    grammar: ".3p.$.pl.$.fut.",
    confidence: "100",
  },
  {
    end1: "oti",
    end2: "issare",
    type: ".v.",
    grammar: ".3p.$.pl.$.fut.",
    confidence: "100",
  },
  {
    end1: "oti",
    end2: "e",
    type: ".v.",
    grammar: ".1p.$.sg.$.imp.",
    confidence: "100",
  },
  {
    end1: "oti",
    end2: "āmase",
    type: ".v.",
    grammar: ".1p.$.pl.$.imp.",
    confidence: "100",
  },
  {
    end1: "oti",
    end2: "eyyāmi",
    type: ".v.",
    grammar: ".1p.$.sg.$.opt.",
    confidence: "100",
  },
  {
    end1: "oti",
    end2: "eyyāma",
    type: ".v.",
    grammar: ".1p.$.pl.$.opt.",
    confidence: "100",
  },
  {
    end1: "oti",
    end2: "eyyaṃ",
    type: ".v.",
    grammar: ".1p.$.sg.$.opt.",
    confidence: "100",
  },
  {
    end1: "oti",
    end2: "eyyāmhe",
    type: ".v.",
    grammar: ".1p.$.pl.$.opt.",
    confidence: "100",
  },
  {
    end1: "oti",
    end2: "issāmi",
    type: ".v.",
    grammar: ".1p.$.sg.$.fut.",
    confidence: "100",
  },
  {
    end1: "oti",
    end2: "issāma",
    type: ".v.",
    grammar: ".1p.$.pl.$.fut.",
    confidence: "100",
  },
  {
    end1: "oti",
    end2: "issaṃ",
    type: ".v.",
    grammar: ".1p.$.sg.$.fut.",
    confidence: "100",
  },
  {
    end1: "oti",
    end2: "issāmhe",
    type: ".v.",
    grammar: ".1p.$.pl.$.fut.",
    confidence: "100",
  },
  {
    end1: "oti",
    end2: "issāmase",
    type: ".v.",
    grammar: ".1p.$.pl.$.fut.",
    confidence: "100",
  },
  {
    end1: "oti",
    end2: "eyyāsi",
    type: ".v.",
    grammar: ".2p.$.sg.$.opt.",
    confidence: "100",
  },
  {
    end1: "oti",
    end2: "eyyātha",
    type: ".v.",
    grammar: ".2p.$.pl.$.opt.",
    confidence: "100",
  },
  {
    end1: "oti",
    end2: "etho",
    type: ".v.",
    grammar: ".2p.$.sg.$.opt.",
    confidence: "100",
  },
  {
    end1: "oti",
    end2: "eyyavho",
    type: ".v.",
    grammar: ".2p.$.pl.$.opt.",
    confidence: "100",
  },
  {
    end1: "oti",
    end2: "issasi",
    type: ".v.",
    grammar: ".2p.$.sg.$.fut.",
    confidence: "100",
  },
  {
    end1: "oti",
    end2: "issatha",
    type: ".v.",
    grammar: ".2p.$.pl.$.fut.",
    confidence: "100",
  },
  {
    end1: "oti",
    end2: "issase",
    type: ".v.",
    grammar: ".2p.$.sg.$.fut.",
    confidence: "100",
  },
  {
    end1: "oti",
    end2: "issavhe",
    type: ".v.",
    grammar: ".2p.$.pl.$.fut.",
    confidence: "100",
  },
  {
    end1: "ti",
    end2: "ti",
    type: ".v.",
    grammar: ".3p.$.sg.$.pres.",
    confidence: "100",
  },
  {
    end1: "ti",
    end2: "nti",
    type: ".v.",
    grammar: ".3p.$.pl.$.pres.",
    confidence: "100",
  },
  {
    end1: "ti",
    end2: "te",
    type: ".v.",
    grammar: ".3p.$.sg.$.pres.",
    confidence: "100",
  },
  {
    end1: "ti",
    end2: "nte",
    type: ".v.",
    grammar: ".3p.$.pl.$.pres.",
    confidence: "100",
  },
  {
    end1: "ti",
    end2: "re",
    type: ".v.",
    grammar: ".3p.$.pl.$.pres.",
    confidence: "100",
  },
  {
    end1: "ti",
    end2: "ssati",
    type: ".v.",
    grammar: ".3p.$.sg.$.fut.",
    confidence: "100",
  },
  {
    end1: "ti",
    end2: "ssanti",
    type: ".v.",
    grammar: ".3p.$.pl.$.fut.",
    confidence: "100",
  },
  {
    end1: "ti",
    end2: "ssate",
    type: ".v.",
    grammar: ".3p.$.sg.$.fut.",
    confidence: "100",
  },
  {
    end1: "ti",
    end2: "ssante",
    type: ".v.",
    grammar: ".3p.$.pl.$.fut.",
    confidence: "100",
  },
  {
    end1: "ti",
    end2: "ssare",
    type: ".v.",
    grammar: ".3p.$.pl.$.fut.",
    confidence: "100",
  },
  {
    end1: "ti",
    end2: "tu",
    type: ".v.",
    grammar: ".3p.$.sg.$.imp.",
    confidence: "100",
  },
  {
    end1: "ti",
    end2: "ntu",
    type: ".v.",
    grammar: ".3p.$.pl.$.imp.",
    confidence: "100",
  },
  {
    end1: "ti",
    end2: "taṃ",
    type: ".v.",
    grammar: ".3p.$.sg.$.imp.",
    confidence: "100",
  },
  {
    end1: "ti",
    end2: "ntaṃ",
    type: ".v.",
    grammar: ".3p.$.pl.$.imp.",
    confidence: "100",
  },
  {
    end1: "ti",
    end2: "sā",
    type: ".v.",
    grammar: ".3p.$.sg.$.cond.",
    confidence: "100",
  },
  {
    end1: "ti",
    end2: "ssa",
    type: ".v.",
    grammar: ".3p.$.sg.$.cond.",
    confidence: "100",
  },
  {
    end1: "ti",
    end2: "ssati",
    type: ".v.",
    grammar: ".3p.$.sg.$.cond.",
    confidence: "100",
  },
  {
    end1: "ti",
    end2: "ssaṃsu",
    type: ".v.",
    grammar: ".3p.$.pl.$.cond.",
    confidence: "100",
  },
  {
    end1: "ti",
    end2: "ssatha",
    type: ".v.",
    grammar: ".3p.$.sg.$.cond.",
    confidence: "100",
  },
  {
    end1: "ti",
    end2: "ssiṃsu",
    type: ".v.",
    grammar: ".3p.$.pl.$.cond.",
    confidence: "100",
  },
  {
    end1: "ti",
    end2: "mi",
    type: ".v.",
    grammar: ".1p.$.sg.$.pres.",
    confidence: "100",
  },
  {
    end1: "ti",
    end2: "ma",
    type: ".v.",
    grammar: ".1p.$.pl.$.pres.",
    confidence: "100",
  },
  {
    end1: "ti",
    end2: "e",
    type: ".v.",
    grammar: ".1p.$.sg.$.pres.",
    confidence: "100",
  },
  {
    end1: "ti",
    end2: "mhe",
    type: ".v.",
    grammar: ".1p.$.pl.$.pres.",
    confidence: "100",
  },
  {
    end1: "ti",
    end2: "mahe",
    type: ".v.",
    grammar: ".1p.$.pl.$.pres.",
    confidence: "100",
  },
  {
    end1: "ti",
    end2: "mha",
    type: ".v.",
    grammar: ".1p.$.pl.$.pres.",
    confidence: "100",
  },
  {
    end1: "ti",
    end2: "mase",
    type: ".v.",
    grammar: ".1p.$.pl.$.pres.",
    confidence: "100",
  },
  {
    end1: "ti",
    end2: "mhase",
    type: ".v.",
    grammar: ".1p.$.pl.$.pres.",
    confidence: "100",
  },
  {
    end1: "ti",
    end2: "ssāmi",
    type: ".v.",
    grammar: ".1p.$.sg.$.fut.",
    confidence: "100",
  },
  {
    end1: "ti",
    end2: "ssāma",
    type: ".v.",
    grammar: ".1p.$.pl.$.fut.",
    confidence: "100",
  },
  {
    end1: "ti",
    end2: "ssaṃ",
    type: ".v.",
    grammar: ".1p.$.sg.$.fut.",
    confidence: "100",
  },
  {
    end1: "ti",
    end2: "ssāmhe",
    type: ".v.",
    grammar: ".1p.$.pl.$.fut.",
    confidence: "100",
  },
  {
    end1: "ti",
    end2: "ssāmase",
    type: ".v.",
    grammar: ".1p.$.pl.$.fut.",
    confidence: "100",
  },
  {
    end1: "ti",
    end2: "mi",
    type: ".v.",
    grammar: ".1p.$.sg.$.imp.",
    confidence: "100",
  },
  {
    end1: "ti",
    end2: "ma",
    type: ".v.",
    grammar: ".1p.$.pl.$.imp.",
    confidence: "100",
  },
  {
    end1: "ti",
    end2: "ssa",
    type: ".v.",
    grammar: ".1p.$.sg.$.cond.",
    confidence: "100",
  },
  {
    end1: "ti",
    end2: "ssamhā",
    type: ".v.",
    grammar: ".1p.$.pl.$.cond.",
    confidence: "100",
  },
  {
    end1: "ti",
    end2: "ssaṃ",
    type: ".v.",
    grammar: ".1p.$.sg.$.cond.",
    confidence: "100",
  },
  {
    end1: "ti",
    end2: "ssāmhase",
    type: ".v.",
    grammar: ".1p.$.pl.$.cond.",
    confidence: "100",
  },
  {
    end1: "ti",
    end2: "si",
    type: ".v.",
    grammar: ".2p.$.sg.$.pres.",
    confidence: "100",
  },
  {
    end1: "ti",
    end2: "tha",
    type: ".v.",
    grammar: ".2p.$.pl.$.pres.",
    confidence: "100",
  },
  {
    end1: "ti",
    end2: "se",
    type: ".v.",
    grammar: ".2p.$.sg.$.pres.",
    confidence: "100",
  },
  {
    end1: "ti",
    end2: "vhe",
    type: ".v.",
    grammar: ".2p.$.pl.$.pres.",
    confidence: "100",
  },
  {
    end1: "ti",
    end2: "ssasi",
    type: ".v.",
    grammar: ".2p.$.sg.$.fut.",
    confidence: "100",
  },
  {
    end1: "ti",
    end2: "ssatha",
    type: ".v.",
    grammar: ".2p.$.pl.$.fut.",
    confidence: "100",
  },
  {
    end1: "ti",
    end2: "ssase",
    type: ".v.",
    grammar: ".2p.$.sg.$.fut.",
    confidence: "100",
  },
  {
    end1: "ti",
    end2: "ssavhe",
    type: ".v.",
    grammar: ".2p.$.pl.$.fut.",
    confidence: "100",
  },
  {
    end1: "ti",
    end2: "hi",
    type: ".v.",
    grammar: ".2p.$.sg.$.imp.",
    confidence: "100",
  },
  {
    end1: "ti",
    end2: "ta",
    type: ".v.",
    grammar: ".2p.$.pl.$.imp.",
    confidence: "100",
  },
  {
    end1: "ti",
    end2: "ssu",
    type: ".v.",
    grammar: ".2p.$.sg.$.imp.",
    confidence: "100",
  },
  {
    end1: "ti",
    end2: "vho",
    type: ".v.",
    grammar: ".2p.$.pl.$.imp.",
    confidence: "100",
  },
  {
    end1: "ti",
    end2: "se",
    type: ".v.",
    grammar: ".2p.$.sg.$.cond.",
    confidence: "100",
  },
  {
    end1: "ti",
    end2: "ssa",
    type: ".v.",
    grammar: ".2p.$.sg.$.cond.",
    confidence: "100",
  },
  {
    end1: "ti",
    end2: "ssasi",
    type: ".v.",
    grammar: ".2p.$.sg.$.cond.",
    confidence: "100",
  },
  {
    end1: "ti",
    end2: "ssatha",
    type: ".v.",
    grammar: ".2p.$.pl.$.cond.",
    confidence: "100",
  },
  {
    end1: "ti",
    end2: "ssase",
    type: ".v.",
    grammar: ".2p.$.sg.$.cond.",
    confidence: "100",
  },
  {
    end1: "ti",
    end2: "ssavhe",
    type: ".v.",
    grammar: ".2p.$.pl.$.cond.",
    confidence: "100",
  },
  {
    end1: "ti",
    end2: "eyya",
    type: ".v.",
    grammar: ".3p.$.sg.$.opt.",
    confidence: "100",
  },
  {
    end1: "ti",
    end2: "eyyuṃ",
    type: ".v.",
    grammar: ".3p.$.pl.$.opt.",
    confidence: "100",
  },
  {
    end1: "ati",
    end2: "i",
    type: ".v.",
    grammar: ".3p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "ati",
    end2: "ī",
    type: ".v.",
    grammar: ".3p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "ati",
    end2: "ā",
    type: ".v.",
    grammar: ".3p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "ati",
    end2: "iṃsu",
    type: ".v.",
    grammar: ".3p.$.pl.$.aor.",
    confidence: "90",
  },
  {
    end1: "ati",
    end2: "ṃ",
    type: ".v.",
    grammar: ".3p.$.pl.$.aor.",
    confidence: "90",
  },
  {
    end1: "ati",
    end2: "uṃū",
    type: ".v.",
    grammar: ".3p.$.pl.$.aor.",
    confidence: "90",
  },
  {
    end1: "ati",
    end2: "ā",
    type: ".v.",
    grammar: ".3p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "ati",
    end2: "a",
    type: ".v.",
    grammar: ".3p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "ati",
    end2: "tthuṃ",
    type: ".v.",
    grammar: ".3p.$.pl.$.aor.",
    confidence: "90",
  },
  {
    end1: "ati",
    end2: "atthuṃ",
    type: ".v.",
    grammar: ".3p.$.pl.$.aor.",
    confidence: "90",
  },
  {
    end1: "ati",
    end2: "iṃ",
    type: ".v.",
    grammar: ".1p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "ati",
    end2: "aṃ",
    type: ".v.",
    grammar: ".1p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "ati",
    end2: "ṃ",
    type: ".v.",
    grammar: ".1p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "ati",
    end2: "a",
    type: ".v.",
    grammar: ".1p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "ati",
    end2: "ā",
    type: ".v.",
    grammar: ".1p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "ati",
    end2: "imha",
    type: ".v.",
    grammar: ".1p.$.pl.$.aor.",
    confidence: "90",
  },
  {
    end1: "ati",
    end2: "imhā",
    type: ".v.",
    grammar: ".1p.$.pl.$.aor.",
    confidence: "90",
  },
  {
    end1: "ati",
    end2: "a",
    type: ".v.",
    grammar: ".1p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "ati",
    end2: "imhe",
    type: ".v.",
    grammar: ".1p.$.pl.$.aor.",
    confidence: "90",
  },
  {
    end1: "ati",
    end2: "i",
    type: ".v.",
    grammar: ".2p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "ati",
    end2: "o",
    type: ".v.",
    grammar: ".2p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "ati",
    end2: "ā",
    type: ".v.",
    grammar: ".2p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "ati",
    end2: "ttha",
    type: ".v.",
    grammar: ".2p.$.pl.$.aor.",
    confidence: "90",
  },
  {
    end1: "ati",
    end2: "se",
    type: ".v.",
    grammar: ".2p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "ati",
    end2: "vhaṃ",
    type: ".v.",
    grammar: ".2p.$.pl.$.aor.",
    confidence: "90",
  },
  {
    end1: "āti",
    end2: "i",
    type: ".v.",
    grammar: ".3p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "āti",
    end2: "ī",
    type: ".v.",
    grammar: ".3p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "āti",
    end2: "ā",
    type: ".v.",
    grammar: ".3p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "āti",
    end2: "iṃsu",
    type: ".v.",
    grammar: ".3p.$.pl.$.aor.",
    confidence: "90",
  },
  {
    end1: "āti",
    end2: "ṃ",
    type: ".v.",
    grammar: ".3p.$.pl.$.aor.",
    confidence: "90",
  },
  {
    end1: "āti",
    end2: "uṃū",
    type: ".v.",
    grammar: ".3p.$.pl.$.aor.",
    confidence: "90",
  },
  {
    end1: "āti",
    end2: "ā",
    type: ".v.",
    grammar: ".3p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "āti",
    end2: "a",
    type: ".v.",
    grammar: ".3p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "āti",
    end2: "tthuṃ",
    type: ".v.",
    grammar: ".3p.$.pl.$.aor.",
    confidence: "90",
  },
  {
    end1: "āti",
    end2: "atthuṃ",
    type: ".v.",
    grammar: ".3p.$.pl.$.aor.",
    confidence: "90",
  },
  {
    end1: "āti",
    end2: "iṃ",
    type: ".v.",
    grammar: ".1p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "āti",
    end2: "aṃ",
    type: ".v.",
    grammar: ".1p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "āti",
    end2: "ṃ",
    type: ".v.",
    grammar: ".1p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "āti",
    end2: "a",
    type: ".v.",
    grammar: ".1p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "āti",
    end2: "ā",
    type: ".v.",
    grammar: ".1p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "āti",
    end2: "imha",
    type: ".v.",
    grammar: ".1p.$.pl.$.aor.",
    confidence: "90",
  },
  {
    end1: "āti",
    end2: "imhā",
    type: ".v.",
    grammar: ".1p.$.pl.$.aor.",
    confidence: "90",
  },
  {
    end1: "āti",
    end2: "a",
    type: ".v.",
    grammar: ".1p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "āti",
    end2: "imhe",
    type: ".v.",
    grammar: ".1p.$.pl.$.aor.",
    confidence: "90",
  },
  {
    end1: "āti",
    end2: "i",
    type: ".v.",
    grammar: ".2p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "āti",
    end2: "o",
    type: ".v.",
    grammar: ".2p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "āti",
    end2: "ā",
    type: ".v.",
    grammar: ".2p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "āti",
    end2: "ttha",
    type: ".v.",
    grammar: ".2p.$.pl.$.aor.",
    confidence: "90",
  },
  {
    end1: "āti",
    end2: "se",
    type: ".v.",
    grammar: ".2p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "āti",
    end2: "vhaṃ",
    type: ".v.",
    grammar: ".2p.$.pl.$.aor.",
    confidence: "90",
  },
  {
    end1: "eti",
    end2: "i",
    type: ".v.",
    grammar: ".3p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "eti",
    end2: "ī",
    type: ".v.",
    grammar: ".3p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "eti",
    end2: "ā",
    type: ".v.",
    grammar: ".3p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "eti",
    end2: "iṃsu",
    type: ".v.",
    grammar: ".3p.$.pl.$.aor.",
    confidence: "90",
  },
  {
    end1: "eti",
    end2: "ṃ",
    type: ".v.",
    grammar: ".3p.$.pl.$.aor.",
    confidence: "90",
  },
  {
    end1: "eti",
    end2: "uṃū",
    type: ".v.",
    grammar: ".3p.$.pl.$.aor.",
    confidence: "90",
  },
  {
    end1: "eti",
    end2: "ā",
    type: ".v.",
    grammar: ".3p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "eti",
    end2: "a",
    type: ".v.",
    grammar: ".3p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "eti",
    end2: "tthuṃ",
    type: ".v.",
    grammar: ".3p.$.pl.$.aor.",
    confidence: "90",
  },
  {
    end1: "eti",
    end2: "atthuṃ",
    type: ".v.",
    grammar: ".3p.$.pl.$.aor.",
    confidence: "90",
  },
  {
    end1: "eti",
    end2: "iṃ",
    type: ".v.",
    grammar: ".1p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "eti",
    end2: "aṃ",
    type: ".v.",
    grammar: ".1p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "eti",
    end2: "ṃ",
    type: ".v.",
    grammar: ".1p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "eti",
    end2: "a",
    type: ".v.",
    grammar: ".1p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "eti",
    end2: "ā",
    type: ".v.",
    grammar: ".1p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "eti",
    end2: "imha",
    type: ".v.",
    grammar: ".1p.$.pl.$.aor.",
    confidence: "90",
  },
  {
    end1: "eti",
    end2: "imhā",
    type: ".v.",
    grammar: ".1p.$.pl.$.aor.",
    confidence: "90",
  },
  {
    end1: "eti",
    end2: "a",
    type: ".v.",
    grammar: ".1p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "eti",
    end2: "imhe",
    type: ".v.",
    grammar: ".1p.$.pl.$.aor.",
    confidence: "90",
  },
  {
    end1: "eti",
    end2: "i",
    type: ".v.",
    grammar: ".2p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "eti",
    end2: "o",
    type: ".v.",
    grammar: ".2p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "eti",
    end2: "ā",
    type: ".v.",
    grammar: ".2p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "eti",
    end2: "ttha",
    type: ".v.",
    grammar: ".2p.$.pl.$.aor.",
    confidence: "90",
  },
  {
    end1: "eti",
    end2: "se",
    type: ".v.",
    grammar: ".2p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "eti",
    end2: "vhaṃ",
    type: ".v.",
    grammar: ".2p.$.pl.$.aor.",
    confidence: "90",
  },
  {
    end1: "oti",
    end2: "i",
    type: ".v.",
    grammar: ".3p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "oti",
    end2: "ī",
    type: ".v.",
    grammar: ".3p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "oti",
    end2: "ā",
    type: ".v.",
    grammar: ".3p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "oti",
    end2: "iṃsu",
    type: ".v.",
    grammar: ".3p.$.pl.$.aor.",
    confidence: "90",
  },
  {
    end1: "oti",
    end2: "ṃ",
    type: ".v.",
    grammar: ".3p.$.pl.$.aor.",
    confidence: "90",
  },
  {
    end1: "oti",
    end2: "uṃū",
    type: ".v.",
    grammar: ".3p.$.pl.$.aor.",
    confidence: "90",
  },
  {
    end1: "oti",
    end2: "ā",
    type: ".v.",
    grammar: ".3p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "oti",
    end2: "a",
    type: ".v.",
    grammar: ".3p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "oti",
    end2: "tthuṃ",
    type: ".v.",
    grammar: ".3p.$.pl.$.aor.",
    confidence: "90",
  },
  {
    end1: "oti",
    end2: "atthuṃ",
    type: ".v.",
    grammar: ".3p.$.pl.$.aor.",
    confidence: "90",
  },
  {
    end1: "oti",
    end2: "iṃ",
    type: ".v.",
    grammar: ".1p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "oti",
    end2: "aṃ",
    type: ".v.",
    grammar: ".1p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "oti",
    end2: "ṃ",
    type: ".v.",
    grammar: ".1p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "oti",
    end2: "a",
    type: ".v.",
    grammar: ".1p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "oti",
    end2: "ā",
    type: ".v.",
    grammar: ".1p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "oti",
    end2: "imha",
    type: ".v.",
    grammar: ".1p.$.pl.$.aor.",
    confidence: "90",
  },
  {
    end1: "oti",
    end2: "imhā",
    type: ".v.",
    grammar: ".1p.$.pl.$.aor.",
    confidence: "90",
  },
  {
    end1: "oti",
    end2: "a",
    type: ".v.",
    grammar: ".1p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "oti",
    end2: "imhe",
    type: ".v.",
    grammar: ".1p.$.pl.$.aor.",
    confidence: "90",
  },
  {
    end1: "oti",
    end2: "i",
    type: ".v.",
    grammar: ".2p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "oti",
    end2: "o",
    type: ".v.",
    grammar: ".2p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "oti",
    end2: "ā",
    type: ".v.",
    grammar: ".2p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "oti",
    end2: "ttha",
    type: ".v.",
    grammar: ".2p.$.pl.$.aor.",
    confidence: "90",
  },
  {
    end1: "oti",
    end2: "se",
    type: ".v.",
    grammar: ".2p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "oti",
    end2: "vhaṃ",
    type: ".v.",
    grammar: ".2p.$.pl.$.aor.",
    confidence: "90",
  },
  {
    end1: "ti",
    end2: "si",
    type: ".v.",
    grammar: ".3p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "ti",
    end2: "sī",
    type: ".v.",
    grammar: ".3p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "ti",
    end2: "sā",
    type: ".v.",
    grammar: ".3p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "ti",
    end2: "siṃsu",
    type: ".v.",
    grammar: ".3p.$.pl.$.aor.",
    confidence: "90",
  },
  {
    end1: "ti",
    end2: "sṃ",
    type: ".v.",
    grammar: ".3p.$.pl.$.aor.",
    confidence: "90",
  },
  {
    end1: "ti",
    end2: "suṃū",
    type: ".v.",
    grammar: ".3p.$.pl.$.aor.",
    confidence: "90",
  },
  {
    end1: "ti",
    end2: "sā",
    type: ".v.",
    grammar: ".3p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "ti",
    end2: "sa",
    type: ".v.",
    grammar: ".3p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "ti",
    end2: "stthuṃ",
    type: ".v.",
    grammar: ".3p.$.pl.$.aor.",
    confidence: "90",
  },
  {
    end1: "ti",
    end2: "satthuṃ",
    type: ".v.",
    grammar: ".3p.$.pl.$.aor.",
    confidence: "90",
  },
  {
    end1: "ti",
    end2: "siṃ",
    type: ".v.",
    grammar: ".1p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "ti",
    end2: "saṃ",
    type: ".v.",
    grammar: ".1p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "ti",
    end2: "sṃ",
    type: ".v.",
    grammar: ".1p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "ti",
    end2: "sa",
    type: ".v.",
    grammar: ".1p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "ti",
    end2: "sā",
    type: ".v.",
    grammar: ".1p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "ti",
    end2: "simha",
    type: ".v.",
    grammar: ".1p.$.pl.$.aor.",
    confidence: "90",
  },
  {
    end1: "ti",
    end2: "simhā",
    type: ".v.",
    grammar: ".1p.$.pl.$.aor.",
    confidence: "90",
  },
  {
    end1: "ti",
    end2: "sa",
    type: ".v.",
    grammar: ".1p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "ti",
    end2: "simhe",
    type: ".v.",
    grammar: ".1p.$.pl.$.aor.",
    confidence: "90",
  },
  {
    end1: "ti",
    end2: "si",
    type: ".v.",
    grammar: ".2p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "ti",
    end2: "so",
    type: ".v.",
    grammar: ".2p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "ti",
    end2: "sā",
    type: ".v.",
    grammar: ".2p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "ti",
    end2: "sttha",
    type: ".v.",
    grammar: ".2p.$.pl.$.aor.",
    confidence: "90",
  },
  {
    end1: "ti",
    end2: "sse",
    type: ".v.",
    grammar: ".2p.$.sg.$.aor.",
    confidence: "90",
  },
  {
    end1: "ti",
    end2: "svhaṃ",
    type: ".v.",
    grammar: ".2p.$.pl.$.aor.",
    confidence: "90",
  },
  {
    end1: "a",
    end2: "e",
    type: ".n.",
    grammar: ".m.$.sg.$.nom.",
    confidence: "50",
  },
  {
    end1: "a",
    end2: "ā",
    type: ".n.",
    grammar: ".m.$.sg.$.inst.",
    confidence: "50",
  },
  {
    end1: "a",
    end2: "asā",
    type: ".n.",
    grammar: ".m.$.sg.$.inst.",
    confidence: "50",
  },
  {
    end1: "a",
    end2: "ā",
    type: ".n.",
    grammar: ".m.$.sg.$.dat.",
    confidence: "50",
  },
  {
    end1: "a",
    end2: "āya",
    type: ".n.",
    grammar: ".m.$.sg.$.gen.",
    confidence: "50",
  },
  {
    end1: "a",
    end2: "ā",
    type: ".n.",
    grammar: ".m.$.sg.$.gen.",
    confidence: "50",
  },
  {
    end1: "a",
    end2: "asi",
    type: ".n.",
    grammar: ".m.$.sg.$.loc.",
    confidence: "50",
  },
  {
    end1: "a",
    end2: "e",
    type: ".n.",
    grammar: ".m.$.sg.$.voc.",
    confidence: "50",
  },
  {
    end1: "a",
    end2: "o",
    type: ".n.",
    grammar: ".m.$.sg.$.voc.",
    confidence: "50",
  },
  {
    end1: "a",
    end2: "āse",
    type: ".n.",
    grammar: ".m.$.pl.$.nom.",
    confidence: "50",
  },
  {
    end1: "a",
    end2: "o",
    type: ".n.",
    grammar: ".m.$.pl.$.nom.",
    confidence: "50",
  },
  {
    end1: "a",
    end2: "ān",
    type: ".n.",
    grammar: ".m.$.pl.$.acc.",
    confidence: "50",
  },
  {
    end1: "a",
    end2: "e",
    type: ".n.",
    grammar: ".m.$.pl.$.inst.",
    confidence: "50",
  },
  {
    end1: "a",
    end2: "ato",
    type: ".n.",
    grammar: ".m.$.pl.$.abl.",
    confidence: "50",
  },
  {
    end1: "a",
    end2: "e",
    type: ".n.",
    grammar: ".nt.$.sg.$.nom.",
    confidence: "50",
  },
  {
    end1: "a",
    end2: "ā",
    type: ".n.",
    grammar: ".nt.$.sg.$.inst.",
    confidence: "50",
  },
  {
    end1: "a",
    end2: "asā",
    type: ".n.",
    grammar: ".nt.$.sg.$.inst.",
    confidence: "50",
  },
  {
    end1: "a",
    end2: "ā",
    type: ".n.",
    grammar: ".nt.$.sg.$.dat.",
    confidence: "50",
  },
  {
    end1: "a",
    end2: "asi",
    type: ".n.",
    grammar: ".nt.$.sg.$.loc.",
    confidence: "50",
  },
  {
    end1: "a",
    end2: "ā",
    type: ".n.",
    grammar: ".nt.$.sg.$.voc.",
    confidence: "50",
  },
  {
    end1: "a",
    end2: "aṃ",
    type: ".n.",
    grammar: ".nt.$.sg.$.voc.",
    confidence: "50",
  },
  {
    end1: "a",
    end2: "āya",
    type: ".n.",
    grammar: ".nt.$.sg.$.gen.",
    confidence: "50",
  },
  {
    end1: "a",
    end2: "ā",
    type: ".n.",
    grammar: ".nt.$.sg.$.gen.",
    confidence: "50",
  },
  {
    end1: "a",
    end2: "o",
    type: ".n.",
    grammar: ".nt.$.pl.$.acc.",
    confidence: "50",
  },
  {
    end1: "a",
    end2: "ato",
    type: ".n.",
    grammar: ".nt.$.pl.$.abl.",
    confidence: "50",
  },
  {
    end1: "a",
    end2: "asī",
    type: ".n.",
    grammar: ".m.$.sg.$.loc.",
    confidence: "50",
  },
  {
    end1: "a",
    end2: "asī",
    type: ".n.",
    grammar: ".nt.$.sg.$.loc.",
    confidence: "50",
  },
  {
    end1: "ā",
    end2: "ā",
    type: ".n.",
    grammar: ".f.$.sg.$.inst.",
    confidence: "50",
  },
  {
    end1: "ā",
    end2: "āto",
    type: ".n.",
    grammar: ".f.$.sg.$.abl.",
    confidence: "50",
  },
  {
    end1: "ā",
    end2: "a",
    type: ".n.",
    grammar: ".f.$.sg.$.voc.",
    confidence: "50",
  },
  {
    end1: "ā",
    end2: "iyo",
    type: ".n.",
    grammar: ".f.$.pl.$.voc.",
    confidence: "50",
  },
  {
    end1: "i",
    end2: "yā",
    type: ".n.",
    grammar: ".f.$.sg.$.gen.",
    confidence: "50",
  },
  {
    end1: "i",
    end2: "yā",
    type: ".n.",
    grammar: ".f.$.sg.$.dat.",
    confidence: "50",
  },
  {
    end1: "i",
    end2: "yā",
    type: ".n.",
    grammar: ".f.$.sg.$.inst.",
    confidence: "50",
  },
  {
    end1: "i",
    end2: "yā",
    type: ".n.",
    grammar: ".f.$.sg.$.abl.",
    confidence: "50",
  },
  {
    end1: "i",
    end2: "yo",
    type: ".n.",
    grammar: ".f.$.pl.$.nom.",
    confidence: "50",
  },
  {
    end1: "i",
    end2: "yo",
    type: ".n.",
    grammar: ".f.$.pl.$.voc.",
    confidence: "50",
  },
  {
    end1: "i",
    end2: "yo",
    type: ".n.",
    grammar: ".f.$.pl.$.acc.",
    confidence: "50",
  },
  {
    end1: "i",
    end2: "e",
    type: ".n.",
    grammar: ".m.$.sg.$.dat.",
    confidence: "50",
  },
  {
    end1: "i",
    end2: "ito",
    type: ".n.",
    grammar: ".m.$.sg.$.abl.",
    confidence: "50",
  },
  {
    end1: "i",
    end2: "e",
    type: ".n.",
    grammar: ".m.$.sg.$.gen.",
    confidence: "50",
  },
  {
    end1: "i",
    end2: "ini",
    type: ".n.",
    grammar: ".m.$.sg.$.loc.",
    confidence: "50",
  },
  {
    end1: "i",
    end2: "e",
    type: ".n.",
    grammar: ".m.$.sg.$.loc.",
    confidence: "50",
  },
  {
    end1: "i",
    end2: "o",
    type: ".n.",
    grammar: ".m.$.sg.$.loc.",
    confidence: "50",
  },
  {
    end1: "i",
    end2: "iyo",
    type: ".n.",
    grammar: ".m.$.pl.$.nom.",
    confidence: "50",
  },
  {
    end1: "i",
    end2: "ino",
    type: ".n.",
    grammar: ".m.$.pl.$.nom.",
    confidence: "50",
  },
  {
    end1: "i",
    end2: "iyo",
    type: ".n.",
    grammar: ".m.$.pl.$.acc.",
    confidence: "50",
  },
  {
    end1: "i",
    end2: "ihi",
    type: ".n.",
    grammar: ".m.$.pl.$.inst.",
    confidence: "50",
  },
  {
    end1: "i",
    end2: "ibhi",
    type: ".n.",
    grammar: ".m.$.pl.$.inst.",
    confidence: "50",
  },
  {
    end1: "i",
    end2: "inaṃ",
    type: ".n.",
    grammar: ".m.$.pl.$.dat.",
    confidence: "50",
  },
  {
    end1: "i",
    end2: "ihi",
    type: ".n.",
    grammar: ".m.$.pl.$.abl.",
    confidence: "50",
  },
  {
    end1: "i",
    end2: "ibhi",
    type: ".n.",
    grammar: ".m.$.pl.$.abl.",
    confidence: "50",
  },
  {
    end1: "i",
    end2: "inaṃ",
    type: ".n.",
    grammar: ".m.$.pl.$.gen.",
    confidence: "50",
  },
  {
    end1: "i",
    end2: "isu",
    type: ".n.",
    grammar: ".m.$.pl.$.loc.",
    confidence: "50",
  },
  {
    end1: "i",
    end2: "iyo",
    type: ".n.",
    grammar: ".m.$.pl.$.voc.",
    confidence: "50",
  },
  {
    end1: "i",
    end2: "iṃ",
    type: ".n.",
    grammar: ".nt.$.sg.$.nom.",
    confidence: "50",
  },
  {
    end1: "i",
    end2: "i",
    type: ".n.",
    grammar: ".nt.$.sg.$.acc.",
    confidence: "50",
  },
  {
    end1: "i",
    end2: "e",
    type: ".n.",
    grammar: ".nt.$.sg.$.dat.",
    confidence: "50",
  },
  {
    end1: "i",
    end2: "ito",
    type: ".n.",
    grammar: ".nt.$.sg.$.abl.",
    confidence: "50",
  },
  {
    end1: "i",
    end2: "e",
    type: ".n.",
    grammar: ".nt.$.sg.$.gen.",
    confidence: "50",
  },
  {
    end1: "i",
    end2: "ini",
    type: ".n.",
    grammar: ".nt.$.sg.$.loc.",
    confidence: "50",
  },
  {
    end1: "i",
    end2: "e",
    type: ".n.",
    grammar: ".nt.$.sg.$.loc.",
    confidence: "50",
  },
  {
    end1: "i",
    end2: "o",
    type: ".n.",
    grammar: ".nt.$.sg.$.loc.",
    confidence: "50",
  },
  {
    end1: "i",
    end2: "iṃ",
    type: ".n.",
    grammar: ".nt.$.sg.$.voc.",
    confidence: "50",
  },
  {
    end1: "i",
    end2: "ī",
    type: ".n.",
    grammar: ".f.$.sg.$.nom.",
    confidence: "50",
  },
  {
    end1: "i",
    end2: "ito",
    type: ".n.",
    grammar: ".f.$.sg.$.abl.",
    confidence: "50",
  },
  {
    end1: "i",
    end2: "myā",
    type: ".n.",
    grammar: ".f.$.sg.$.gen.",
    confidence: "50",
  },
  {
    end1: "i",
    end2: "o",
    type: ".n.",
    grammar: ".f.$.sg.$.loc.",
    confidence: "50",
  },
  {
    end1: "i",
    end2: "āyaṃ",
    type: ".n.",
    grammar: ".f.$.sg.$.loc.",
    confidence: "50",
  },
  {
    end1: "i",
    end2: "u",
    type: ".n.",
    grammar: ".f.$.sg.$.loc.",
    confidence: "50",
  },
  {
    end1: "i",
    end2: "ī",
    type: ".n.",
    grammar: ".f.$.sg.$.voc.",
    confidence: "50",
  },
  {
    end1: "i",
    end2: "ihī",
    type: ".n.",
    grammar: ".m.$.pl.$.inst.",
    confidence: "50",
  },
  {
    end1: "i",
    end2: "ibhī",
    type: ".n.",
    grammar: ".m.$.pl.$.inst.",
    confidence: "50",
  },
  {
    end1: "i",
    end2: "ihī",
    type: ".n.",
    grammar: ".m.$.pl.$.abl.",
    confidence: "50",
  },
  {
    end1: "i",
    end2: "ibhī",
    type: ".n.",
    grammar: ".m.$.pl.$.abl.",
    confidence: "50",
  },
  {
    end1: "i",
    end2: "isū",
    type: ".n.",
    grammar: ".m.$.pl.$.loc.",
    confidence: "50",
  },
  {
    end1: "ī",
    end2: "inī",
    type: ".n.",
    grammar: ".m.$.sg.$.voc.",
    confidence: "50",
  },
  {
    end1: "ī",
    end2: "yā",
    type: ".n.",
    grammar: ".f.$.sg.$.gen.",
    confidence: "50",
  },
  {
    end1: "ī",
    end2: "yā",
    type: ".n.",
    grammar: ".f.$.sg.$.dat.",
    confidence: "50",
  },
  {
    end1: "ī",
    end2: "yā",
    type: ".n.",
    grammar: ".f.$.sg.$.inst.",
    confidence: "50",
  },
  {
    end1: "ī",
    end2: "yā",
    type: ".n.",
    grammar: ".f.$.sg.$.abl.",
    confidence: "50",
  },
  {
    end1: "ī",
    end2: "yā",
    type: ".n.",
    grammar: ".f.$.sg.$.loc.",
    confidence: "50",
  },
  {
    end1: "ī",
    end2: "yaṃ",
    type: ".n.",
    grammar: ".f.$.sg.$.loc.",
    confidence: "50",
  },
  {
    end1: "ī",
    end2: "yo",
    type: ".n.",
    grammar: ".f.$.pl.$.nom.",
    confidence: "50",
  },
  {
    end1: "ī",
    end2: "i",
    type: ".n.",
    grammar: ".m.$.sg.$.nom.",
    confidence: "50",
  },
  {
    end1: "ī",
    end2: "iyo",
    type: ".n.",
    grammar: ".m.$.pl.$.nom.",
    confidence: "50",
  },
  {
    end1: "ī",
    end2: "iye",
    type: ".n.",
    grammar: ".m.$.pl.$.acc.",
    confidence: "50",
  },
  {
    end1: "ī",
    end2: "iyaṃ",
    type: ".n.",
    grammar: ".m.$.sg.$.acc.",
    confidence: "50",
  },
  {
    end1: "ī",
    end2: "ito",
    type: ".n.",
    grammar: ".f.$.sg.$.abl.",
    confidence: "50",
  },
  {
    end1: "ī",
    end2: "īto",
    type: ".n.",
    grammar: ".f.$.sg.$.abl.",
    confidence: "50",
  },
  {
    end1: "ī",
    end2: "āyo",
    type: ".n.",
    grammar: ".f.$.pl.$.nom.",
    confidence: "50",
  },
  {
    end1: "ī",
    end2: "āyo",
    type: ".n.",
    grammar: ".f.$.pl.$.nom.",
    confidence: "50",
  },
  {
    end1: "ī",
    end2: "āyo",
    type: ".n.",
    grammar: ".f.$.pl.$.nom.",
    confidence: "50",
  },
];
